import { SHOW_SELECTED_URL_PARAM } from '@/constants/constants';
import parseAsBoolean from '@/utils/parseAsBoolean';

import { FILTER_KEYS } from '../constants';
import type { FilterState } from '../types/filter.types';

export function extractFiltersFromParams(searchParams: URLSearchParams): FilterState {
  return {
    only: searchParams.get('only'),
    [SHOW_SELECTED_URL_PARAM]: parseAsBoolean(searchParams.get(SHOW_SELECTED_URL_PARAM)),
    search: searchParams.get('search'),
    [FILTER_KEYS.COMMODITY]: searchParams.get(FILTER_KEYS.COMMODITY),
    [FILTER_KEYS.TRADING_HUB]: searchParams.get(FILTER_KEYS.TRADING_HUB),
    [FILTER_KEYS.DELIVERY_BASIS]: searchParams.get(FILTER_KEYS.DELIVERY_BASIS),
    [FILTER_KEYS.PRICING_BASIS]: searchParams.get(FILTER_KEYS.PRICING_BASIS),
    [FILTER_KEYS.UNITS]: searchParams.get(FILTER_KEYS.UNITS),
    [FILTER_KEYS.CURRENCY]: searchParams.get(FILTER_KEYS.CURRENCY),
    [FILTER_KEYS.FREQUENCY]: searchParams.get(FILTER_KEYS.FREQUENCY),
    [FILTER_KEYS.INDEX_MODULE]: searchParams.get(FILTER_KEYS.INDEX_MODULE)
  };
}
